import { Component, Input, inject } from "@angular/core";
import { LinkModel } from "@models/generic/LinkModel";
import { RiskDataService } from "@app/risk/services/RiskDataService";
import { RiskModel } from "@app/risk/models/RiskModel";
import { ThirdPartyLinkableComponent } from "@app/thirdparty/thirdparty-linkable.component";

@Component({
    selector: "risk-thirdparty",
    templateUrl: "./risk-thirdparty.component.html",
    imports: [ThirdPartyLinkableComponent],
})
export class RiskThirdpartyComponent {
    private _riskDS = inject(RiskDataService);

    @Input() risk: RiskModel;

    linked: LinkModel[] = [];
    unlinked: LinkModel[] = [];
    isLoading = true;

    load() {
        this.isLoading = true;
        this._riskDS.getLinkedThirdParties(this.risk.guid).subscribe(data => {
            this.linked = data;

            this.isLoading = false;
        });
    }
}
